import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getAdditionalFees as getAdditionalFeesApi,
  addNewAdditionalFee as addNewAdditionalFeeApi,
  updateAdditionalFee as updateAdditionalFeeApi,
  deleteAdditionalFee as deleteAdditionalFeeApi,
} from "../../helpers/realbackend_helper";

export const getAdditionalFees = createAsyncThunk(
  "addfee/getAdditionalFees",
  async () => {
    try {
      const response = await getAdditionalFeesApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewAdditionalFee = createAsyncThunk(
  "addfee/addNewAdditionalFee",
  async (addfee) => {
    try {
      const response = addNewAdditionalFeeApi(addfee);
      toast.success("Шинэ нэмэлт хураамжийг амжилттай нэмлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Шинэ нэмэлт хураамжийг нэмэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateAdditionalFee = createAsyncThunk(
  "addfee/updateAdditionalFee",
  async (addfee) => {
    try {
      const response = updateAdditionalFeeApi(addfee);
      toast.success("Нэмэлт хураамжийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Нэмэлт хураамжийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteAdditionalFee = createAsyncThunk(
  "addfee/deleteAdditionalFee",
  async (addfee) => {
    try {
      const response = deleteAdditionalFeeApi(addfee);
      toast.success("Нэмэлт хураамжийг амжилттай устгалаа", {
        autoClose: 3000,
      });
      return { addfee, ...response };
    } catch (error) {
      toast.error("Нэмэлт хураамжийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);
